/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/day_name.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Returns the name of the weekday for date based on the configured Locale.
 *
 * @example
 * ROW dt = to_datetime("1953-09-02T00:00:00.000Z")
 * | EVAL weekday = DAY_NAME(dt);
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'day_name',
  signatures: [
    {
      params: [
        {
          name: 'date',
          type: 'date',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'keyword',
    },
    {
      params: [
        {
          name: 'date',
          type: 'date_nanos',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'keyword',
    },
  ],
  preview: false,
  snapshotOnly: false,
};

export default definition;
